export default {
  width: "100%"
};
